import type { CompanyRole } from '@/features/permissions/domain/permission'
import type { NotifyPort } from '@/features/messages/domain/notify'
import type { User, UserPort } from '../domain/user'

const updateUserRole = async (port: UserPort, id: string, companyRole: CompanyRole, notify: NotifyPort): Promise<User> => {
	try {
		const user = await port.updateRole(id, companyRole)
		notify.success('member.roleUpdated')
		return user
	} catch {
		notify.error('member.roleUpdateFailed')
		throw new Error('Failed to update role.')
	}
}

export { updateUserRole }
